export class TranscoderJobViewModel {
  constructor(
    public id: string,
    public name: string,
    public destination: string,
    public actualStartTime: string,
    public actualEndTime: string,
    public estimatedEndTime: string,
    public duration: string,
    public status: string,
    public priority: string,
    public transcodingProfile?: number,
  ) {}
}
